import React, { FC } from 'react';
import { Field } from 'react-final-form';
import { ButtonGroup, Theme, styled } from '@material-ui/core';
import {
  Button,
  Icons,
  FormControl,
  TextFieldAdapter,
  validations,
} from '../../../../shared/components';
import { useTranslation } from 'react-i18next';
import { FontAwesomeSpriteButton } from '../../../../shared/components/FontAwesomeLocal';
import { SpriteIconsSolid } from 'src/config/api/models/FontAwesome';

type Props = {
  handleSubmit: (event: any) => void;
  handleReset: () => void;
};

const StyledForm = styled('form')<Theme>(({ theme }) => ({
  display: 'flex',
  margin: 0,
  '& > *:not(:last-child)': {
    paddingRight: theme.spacing(1),
  },
}));

const StyledButtonGroup = styled(ButtonGroup)({
  display: 'block',
  paddingTop: 0,
});

const TrajectoryEditableTitleForm: FC<Props> = ({ handleSubmit, handleReset }) => {
  const { t } = useTranslation();

  return (
    <>
      <StyledForm onSubmit={handleSubmit}>
        <FormControl id="title" required>
          <Field
            name="title"
            defaultValue="trajectory title"
            component={TextFieldAdapter}
            validate={validations(t).required}
            InputProps={{
              endAdornment: (
                <FontAwesomeSpriteButton
                  buttonStyle={{ padding: 0 }}
                  icon={SpriteIconsSolid.ARROW_ROTATE_LEFT}
                  color={'grey'}
                  iconSize="lg"
                  onClick={() => handleReset()}
                ></FontAwesomeSpriteButton>
              ),
            }}
          />
        </FormControl>
        <StyledButtonGroup>
          <Button type="submit" icon={Icons.EDIT}>
            titel hernoemen
          </Button>
        </StyledButtonGroup>
      </StyledForm>
    </>
  );
};

export default TrajectoryEditableTitleForm;
